/* This is the root index - Used for 
1. Redering reactDOM
2. Importing global Styles 
3. Listening to Store
*/

import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import AltContainer from 'alt-container';
import Actions from './appFlux/action'
import store from './appFlux/Store'
import { BrowserRouter as Router } from "react-router-dom";
import MainContainer from './MainContainer';
import './styles/themify-icons.css'
import './styles/icofont.min.css'
import 'bootstrap/dist/css/bootstrap.css';
import './styles/index.scss'
import "react-datepicker/dist/react-datepicker.css";


ReactDOM.render(
    <Router>
        <AltContainer stores={{ store }}>
            <MainContainer />
        </AltContainer>
    </Router>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();